import { useState, useEffect } from "react";
import SideMenu from "../../features/sideMenu/SideMenu";
import Map from "../../ui/map/Map";
import ButtonStyledSelect from "../../ui/select/selection";
import StatusActivo from "../../assets/img/svg/providers/installersStatusGreen.svg";
import StatusInactivo from "../../assets/img/svg/providers/installersStatusRed.svg";
import "./MapInstaller.responsive.css";
import { itemsProviders } from "../../constants/providers";

const MapInstallers = ({ installersMap }) => {
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [filteredInstallers, setFilteredInstallers] = useState([]);

  const statusOptions = [
    { value: "instalador_activo", label: "Activo" },
    { value: "instalador_inactivo", label: "Inactivo" },
  ];

  useEffect(() => {
    const baseList =
      selectedStatus.length === 0
        ? installersMap
        : installersMap.filter((installer) =>
            selectedStatus.some((status) => installer.icon.includes(status))
          );

    const withInfo = baseList.map((installer) => ({
      ...installer,
      info: {
        nombre: installer.nombre || "Sin nombre",
        gafete: installer.numGafete || "Sin gafete",
        empresa: installer.empresa || "Sin empresa",
        fecha: installer.fecha || "Sin fecha",
        status: installer.icon.includes("instalador_activo")
          ? "Activo"
          : "Inactivo",
      },
    }));

    setFilteredInstallers(withInfo);
  }, [selectedStatus, installersMap]);

  const inactiveInstallers = installersMap.filter((i) =>
    i.icon.includes("instalador_inactivo.png")
  ).length;
  const activeInstallers = installersMap.length - inactiveInstallers;

  return (
    <div className="mi-container" style={{ display: "flex", width: "100%" }}>
      {/* Sidebar */}
      <div className="mi-sidebar" style={{ width: "12rem" }}>
        <SideMenu items={itemsProviders} />
      </div>

      {/* Contenido principal */}
      <div
        className="mi-main"
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          padding: "10px",
        }}
      >
        <h1 className="map-title">Mapa de instaladores</h1>

        {/* Banda de controles */}
        <div
          className="mi-controls"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0rem",
            marginBottom: "8px",
          }}
        >
          {/* Filtro */}
          <div
            className="mi-selectWrap"
            style={{
              width: "auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <ButtonStyledSelect
              options={statusOptions}
              value={statusOptions.filter((opt) =>
                selectedStatus.includes(opt.value)
              )}
              onChange={(opts) =>
                setSelectedStatus((opts || []).map((o) => o.value))
              }
              isMulti
              placeholder="Filtrar por estatus"
            />
          </div>

          {/* Contadores */}
          <div className="mi-counters">
            <div className="map-status-status d-flex">
              <img src={StatusActivo} alt="Activos" />
              <div className="map-status-status-text">
                <p className="status-label">Activos</p>
                <p className="status-value">{activeInstallers}</p>
              </div>
            </div>

            <div className="map-status-status d-flex">
              <img src={StatusInactivo} alt="Inactivos" />
              <div className="map-status-status-text">
                <p className="status-label">Inactivos</p>
                <p className="status-value">{inactiveInstallers}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Mapa */}
        <div className="mi-mapWrap">
          <Map installersStatus markers={filteredInstallers} zoom={6} />
        </div>
      </div>
    </div>
  );
};

export default MapInstallers;
